/**
 * Helpers for the "paid online cancel → refund CRM ticket" rule.
 *
 * Auto-creation itself lives in dropit_backend (cancel signal) with a
 * Fasto_BI poller as backfill. The SPA uses this to default the create
 * drawer and surface the same eligibility rule in copy.
 *
 * Prepaid = payment_type contains CIPS or Fonepay (incl. QR variants).
 * Do not use is_payment_done — that flag is unreliable for these gateways.
 */

const PREPAID_PAYMENT_MARKERS = ['cips', 'fonepay'] as const;

export function isPrepaidOnlinePayment(
  paymentType: string | null | undefined,
): boolean {
  const pt = (paymentType ?? '').trim().toLowerCase();
  if (!pt) return false;
  return PREPAID_PAYMENT_MARKERS.some((marker) => pt.includes(marker));
}

export function orderNeedsAutoRefundTicket(order: {
  status?: string | null;
  payment_type?: string | null;
  is_payment_done?: boolean | null;
} | null | undefined): boolean {
  if (!order) return false;
  if ((order.status ?? '').toLowerCase() !== 'cancelled') return false;
  return isPrepaidOnlinePayment(order.payment_type);
}
